module.exports = __webpack_public_path__ + "img/fav_box05.8be0e517.png";